import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

import { ApplicationState } from "../../store";
import * as AuthenticationStore from "../../store/AuthenticationReducer";
import Form from "../Form";
import TextInput from "../TextInput";
import AuthenticationScreen from "../AuthenticationScreen";

const LoginForm: React.FC = () => {
  const [formState, setFormState] = useState({ username: "", password: "" });
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const [passwordFieldTouched, setPasswordFieldTouched] = useState(false);
  const { isAuthenticated, responseMessage, isLoading } = useSelector(
    (state: ApplicationState) => state.authentication
  );
  const dispatch = useDispatch();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();
    dispatch(
      AuthenticationStore.actionCreators.attemptAuthentication({
        username: formState.username,
        password: formState.password,
      })
    );
    setFormState({ ...formState });
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormState({ ...formState, [name]: value });
  };

  return isAuthenticated ? (
    <Redirect to="/financial-info" />
  ) : (
    <AuthenticationScreen
      additionalLink={{ to: "/passwordRecovery", label: "Forgot password?" }}
    >
      <Form
        {...{ isLoading, responseMessage }}
        onSubmit={handleSubmit}
        buttonText="Login"
        buttonSize="extraLarge"
        buttonJustify="center"
      >
        <TextInput
          label="Username"
          name="username"
          id="username"
          size="large"
          required
          value={formState.username}
          onChange={onChange}
        />
        <div style={{ position: "relative" }}>
          <TextInput
            label="Password"
            name="password"
            id="password"
            size="large"
            type={isPasswordShown ? "text" : "password"}
            required
            value={formState.password}
            onChange={onChange}
            onKeyPress={() => setPasswordFieldTouched(true)}
          />
          <div
            onClick={() => setIsPasswordShown(!isPasswordShown)}
            style={{
              position: "absolute",
              top: 42,
              right: passwordFieldTouched ? "35px" : "15px",
              cursor: "pointer",
              fontSize: "18px",
            }}
          >
            {isPasswordShown ? <EyeOutlined /> : <EyeInvisibleOutlined />}
          </div>
        </div>
      </Form>
    </AuthenticationScreen>
  );
};

export default LoginForm;
